var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-container"},[_c('ul',{staticClass:"tab-head"},[_vm._t("default")],2),_c('j-content-container',{attrs:{"panels":_vm.panels}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }